<template>
  <div class="highlights-expanded-model-container">
    <div class="banner">
      <img class="banner-image" :src="imagePath" alt="Banner do destaque" />
    </div>
    <div class="banner-gradient"></div>
    <div class="products-section d-flex flex-row justify-space-between">
      <product-card
        variant="use-background-card"
        product-image-src="highlight-products-images/product-beats-1.png"
        chip-label="Desconto"
        rule-chip-label="Máximo x por CPF *"
        discount-label="- 15%"
        :price="4.5"
        :discount-number="5"
        product-name="Produto exemplo 1"
        product-measure="Unidade"
        product-description="Válido até 08/10 ou enquanto houver estoque"
      />
      <product-card
        variant="use-background-card"
        product-image-src="highlight-products-images/product-beats-2.png"
        chip-label="Desconto"
        rule-chip-label="Máximo x por CPF *"
        discount-label="- 15%"
        :price="4.5"
        :discount-number="5"
        product-name="Produto exemplo 2"
        product-measure="Quilo"
        product-description="Válido até 08/10 ou enquanto houver estoque"
      />
    </div>
  </div>
</template>
<script>
import { highlightOffer } from '../../../mixins/highlight-offer'

export default {
  name: 'ExpandedModel',
  components: {
    ProductCard: () => import('./ProductCard.vue'),
  },
  mixins: [highlightOffer],
  data: () => ({}),
  computed: {
    imagePath() {
      const url = this.highlightBannerImage
      return this.isExpandedModel ? url || require('@/assets/app-default-banner.jpg') : require('@/assets/app-default-banner.jpg')
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.highlights-expanded-model-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .banner {
    width: 100%;
    height: 246px;
    flex-shrink: 0;
    border-radius: 8px;
    .banner-image {
      border-radius: 8px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .banner-gradient {
    width: 100%;
    height: 246px;
    position: absolute;
    top: 14px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 70%, #f5f5f5 100%);
  }
  padding: 14px 12px 0px 12px;
  .products-section {
    gap: 10px;
    margin-top: -60px;
    z-index: 1;
  }
}
</style>
